<template>
  <div class="bindingUserInfoList">
    <div class="list">
      <div
        class="item"
        v-for="(item,index) in bindingUserInfoList"
        :key="index"
      >
        <div class="left">
          <svg :id="'barcode'+item.barCode"></svg>
          <!-- <img
            src="../../assets/images/updataFile/barcodeImg.png"
            alt="条码号"
          >
          <div class="barcode">
            {{item.barCode}}</div> -->
        </div>
        <div
          class="del"
          @click="del(index)"
        >删除</div>
      </div>
    </div>
    <div class="btnBox">
      <div
        class="btn add"
        @click="add(subOrderNo)"
      >继续添加</div>
      <div
        class="btn save"
        @click="save"
      >提交信息</div>
    </div>
  </div>
</template>

<script>
import JsBarcode from "jsbarcode";
export default {
  data() {
    return {
      subOrderNo: "",
      bindingUserInfoList: []
    };
  },
  created() {},
  methods: {
    add(subOrderNo) {
      this.$router.push({
        name: "sweepCodeBinding",
        query: {
          subOrderNo: subOrderNo
        }
      });
    },
    save() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let list = JSON.parse(localStorage.getItem("bindingUserInfoList"));
        this.$loading("提交中");
        this.$http
          .post(`/detectBox/batchBindBox`, list, {
            qs: "no"
          })
          .then(res => {
            if (res.data.code == 200) {
              localStorage.removeItem("bindingUserInfoList");
              this.$tootsSuccess("保存成功");
              setTimeout(() => {
                this.$router.replace({
                  name: "MyTesting"
                });
              }, 1500);
            } else this.$toots(res.data.msg);
          })
          .catch(err => {
            this.$toots("系统正在升级，请稍后");
          });
      }
    },
    del(index) {
      let list = this.bindingUserInfoList;
      list.splice(index, 1);
      if (list.length == 0) {
        localStorage.removeItem("bindingUserInfoList");
        this.$router.push({
          name: "sweepCodeBinding",
          query: {
            subOrderNo: this.subOrderNo
          }
        });
        return;
      }
      this.bindingUserInfoList = list;
      localStorage.setItem("bindingUserInfoList", JSON.stringify(list));
    }
  },
  mounted() {
    this.subOrderNo = this.$route.query.subOrderNo;
    this.bindingUserInfoList = JSON.parse(
      localStorage.getItem("bindingUserInfoList")
    );
    let list = this.bindingUserInfoList;
    setTimeout(() => {
      for (let i = 0; i < list.length; i++) {
        JsBarcode("#barcode" + list[i].barCode, list[i].barCode, {
          text: list[i].barCode,
          width: 1.8,
          height: 60
        });
      }
    }, 200);
  }
};
</script>

<style lang='less' scoped>
.bindingUserInfoList {
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .list {
    flex: 1;
    padding: 30px;
    .item::first-child {
      margin-top: 0;
    }
    .item {
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px;
      border-radius: 10px;
      margin-top: 20px;
      .left {
        // width: 405px;
        flex: 1;
        // img {
        //   width: 405px;
        //   height: 144px;
        // }
        .barcode {
          text-align: center;
          font-size: 36px;
          letter-spacing: 13px;
        }
      }
      .del {
        width: 180px;
        height: 76px;
        line-height: 76px;
        text-align: center;
        font-size: 34px;
        color: #1968a8;
        border-radius: 10px;
        border: 1PX solid #1968a8;
      }
    }
  }
  .btnBox {
    height: 260px;
    margin-top: 30px;
  }
  .btn {
    width: 660px;
    margin: 0 auto;
    height: 80px;
    line-height: 80px;
    border-radius: 80px;
    text-align: center;
    font-size: 34px;
  }
  .save {
    margin-top: 40px;
    color: #fff;
    background-color: #1968a8;
  }
  .add {
    color: #1968a8;
    border: 1PX solid #1968a8;
  }
}
</style>
